import React, { ElementType } from 'react';
import useReplacedInnerHtml from '@utils/useReplacedInnerHtml';
import { Typography } from './design/Typography';

interface Props {
  children: string | undefined;
  as?: ElementType;
  [key: string]: any;
}

const ReplacedText: React.FC<Props> = ({ as: Component = Typography, children, ...rest }) => {
  const textHtml = useReplacedInnerHtml(children);

  return <Component dangerouslySetInnerHTML={{ __html: textHtml }} {...rest} />;
};

export default ReplacedText;
